import axios from 'axios'
import { stringify } from 'query-string'

export const getUsers = (payload, config) => {
  const query = stringify(payload)
  return axios.get(`/users?${query}`, config)
}

export const addUser = (data) => {
  return axios.post(`/users`, data)
}

export const getUser = (id) => {
  return axios.get(`/users/${id}`)
}

export const updateUser = (data, id) => {
  return axios.put(`/users/${id}`, data)
}

export const deleteUser = (id) => {
  return axios.delete(`/users/${id}`)
}

export const resendInvitation = ({ id }) => {
  return axios.post(`/users/resendInvitation/${id}`)
}

export const updateReadNews = (id) => {
  return axios.patch(`/users/${id}/news/read`)
}
